// layout
import LayoutLogin from "../Container/Layout/LayoutLogin";

// style
import styles from "../Styles/Authentication/Login.module.css"

// component
import BtnBack from "../Components/Authentication/BtnBack";
import { Context } from "../Context/Context";
import { useContext } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { LoginSchema } from "../Components/Validations/Validation";
import { userAuthentication } from "../Services/ContectService"
import { toast } from "react-toastify";

const Login = () => {

    const { json, setPhoneNum, numberconvert, setLoading } = useContext(Context);
    const content = json?.Login;
    let navigate = useNavigate();

    const userAuthenticationHandeler = async (values) => {
        values.email_or_phone = numberconvert(values.email_or_phone);
        setLoading(true);
        try {
            const { status } = await userAuthentication(values);
            if (status === 200) {
                setPhoneNum(values.email_or_phone);
                setLoading(false);
                return navigate("/loginPassword");
            } else {
                toast.error(json.toast.err_1);
            }
        } catch (error) {
            if (error?.response?.status === 404) {
                setLoading(false);
                toast.error(json.toast.login_2);
                return navigate("/register")
            } else {
                setLoading(false);
                toast.error(json.toast.err_1);
            }
        }
    };

    return (
        <LayoutLogin>
            <div className={styles.formLogin}>
                <div className="d-flex flex-column align-items-center gap-3 mb-4">
                    <svg width="72" height="72" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M43 0.8125C34.6561 0.8125 26.4996 3.28675 19.5619 7.92238C12.6242 12.558 7.21692 19.1468 4.02385 26.8555C0.830779 34.5643 -0.00467408 43.0468 1.62314 51.2304C3.25095 59.4139 7.26893 66.931 13.169 72.8311C19.069 78.7311 26.5861 82.7491 34.7696 84.3769C42.9532 86.0047 51.4357 85.1692 59.1445 81.9762C66.8532 78.7831 73.442 73.3758 78.0776 66.4381C82.7133 59.5004 85.1875 51.3439 85.1875 43C85.1751 31.815 80.7264 21.0916 72.8174 13.1826C64.9084 5.27363 54.185 0.824907 43 0.8125ZM24.0821 69.7852C26.2581 66.8097 29.1053 64.3896 32.3924 62.7212C35.6795 61.0529 39.3138 60.1834 43 60.1834C46.6863 60.1834 50.3205 61.0529 53.6076 62.7212C56.8947 64.3896 59.7419 66.8097 61.918 69.7852C56.389 73.7062 49.7782 75.8124 43 75.8124C36.2218 75.8124 29.611 73.7062 24.0821 69.7852ZM32.0625 39.875C32.0625 37.7118 32.704 35.5971 33.9058 33.7985C35.1076 31.9998 36.8159 30.5979 38.8144 29.7701C40.813 28.9422 43.0121 28.7256 45.1338 29.1477C47.2555 29.5697 49.2044 30.6114 50.734 32.141C52.2636 33.6707 53.3053 35.6195 53.7274 37.7412C54.1494 39.8629 53.9328 42.062 53.1049 44.0606C52.2771 46.0592 50.8752 47.7674 49.0766 48.9692C47.2779 50.171 45.1632 50.8125 43 50.8125C40.0992 50.8125 37.3172 49.6602 35.266 47.609C33.2149 45.5578 32.0625 42.7758 32.0625 39.875ZM68.7813 63.2891C65.743 59.4247 61.8705 56.2973 57.4531 54.1406C60.2683 51.2898 62.1776 47.6701 62.9407 43.7369C63.7038 39.8037 63.2867 35.7326 61.7418 32.0359C60.1969 28.3392 57.5933 25.1818 54.2585 22.9612C50.9237 20.7405 47.0066 19.5556 43 19.5556C38.9935 19.5556 35.0764 20.7405 31.7416 22.9612C28.4067 25.1818 25.8031 28.3392 24.2582 32.0359C22.7134 35.7326 22.2963 39.8037 23.0594 43.7369C23.8225 47.6701 25.7317 51.2898 28.5469 54.1406C24.1296 56.2973 20.257 59.4247 17.2188 63.2891C13.4025 58.4514 11.0256 52.6369 10.36 46.5112C9.69439 40.3856 10.7671 34.1963 13.4552 28.6518C16.1434 23.1074 20.3383 18.4319 25.5599 15.1606C30.7816 11.8893 36.8188 10.1543 42.9805 10.1543C49.1422 10.1543 55.1794 11.8893 60.401 15.1606C65.6226 18.4319 69.8176 23.1074 72.5058 28.6518C75.1939 34.1963 76.2666 40.3856 75.601 46.5112C74.9354 52.6369 72.5584 58.4514 68.7422 63.2891H68.7813Z" fill="black" />
                    </svg>
                    <h3>{content.title}</h3>
                </div>
                <Formik
                    initialValues={{
                        email_or_phone: ""
                    }}
                    validationSchema={LoginSchema}
                    onSubmit={(values) => {
                        userAuthenticationHandeler(values);
                    }}

                >
                    <Form className="w-100">
                        <div className="main-form-group mb-3">
                            <label htmlFor="" className="mian-label">{content.inputGroup1.label}</label>
                            <div className="input-frame input-frame-two">
                                <Field
                                    name="email_or_phone"
                                    type="text"
                                    placeholder={content.inputGroup1.placeholder}
                                />
                            </div>
                            <ErrorMessage
                                name="email_or_phone"
                                render={(msg) => (
                                    <div className="main-error">{msg}</div>
                                )}
                            />
                        </div>

                        <div className={styles.formLoginBtns}>
                            <button type="submit" className={styles.formLoginBtnActive}>{content.btn1}</button>
                            <BtnBack text={content.btn2} />
                        </div>

                    </Form>

                </Formik>
                <p>
                    {content.textConfirmation.text1}&nbsp;
                    <a
                        href="https://wisercam.com/terms-and-conditions/"
                        target="_blank"
                        rel="noreferrer"
                        className="color-info"
                    >
                        {content.textConfirmation.link}
                    </a>&nbsp;
                    {content.textConfirmation.text2}
                </p>
            </div>
        </LayoutLogin>
    );
}

export default Login;

